import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CombinedResult } from 'src/business/chrome/search-bar/search-bar.component';
import { CatalogContentAndSearchResolver } from 'src/core-lib/navigation/services/content.resolver';
import { UrlUtil } from 'src/utils/url.util';



@Component({
    selector: 'app-catalog-search',
    templateUrl: './catalog-search.component.html',
    styleUrls: ['./catalog-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogSearchComponent implements OnDestroy, OnInit {
    formGroup: FormGroup<{ search: FormControl<string>; }>;
    results$: Observable<CombinedResult>;
    state$: Observable<'error' | 'pending' | 'success'>;
    amount$: Observable<number>;

    sub: Subscription;

    constructor(
        private productSearchService: CatalogContentAndSearchResolver,
        private _route: ActivatedRoute,
    ) {
        this.amount$ = this.productSearchService.result$.pipe(startWith(this._route.snapshot.data.content.result), map(_ => _?.totalResults ?? 0), startWith(0));
    }
    ngOnInit(): void {
        let value = this.productSearchService.urlModel(globalThis.document.location.href).searchTerms;
        if (value) { // initial value
            this._setValue(value, 'search-catalog-input');
            this._setValue(value, 'search-catalog-input-hidden');

        } else
            this._setValue(window['search-catalog-input'].value, 'search-catalog-input-hidden');
    }
    ngOnDestroy(): void {
        if (this.sub != null && !this.sub.closed)
            this.sub.unsubscribe()
    }

    private _setValue(value: string, id: string, retries = 0) {
        if (retries > 30) // > 30 sec to set value stop trying
            return;
        let elm = window[id];
        if (!elm)
            setTimeout(() => this._setValue(value, id, retries++), 1000)
        else
            elm.value = value;

    }

    search(event?: SubmitEvent, value?: string) {
        if (value) { // initial value
            this._setValue(value, 'search-catalog-input');
            this._setValue(value, 'search-catalog-input-hidden');

        } else
            this._setValue(window['search-catalog-input'].value, 'search-catalog-input-hidden');

        if (!event)
            return false;
        if (window['search-catalog-input'].value.length === 0 || window['search-catalog-input'].value.length > 2 || value != null)
            this.productSearchService.updateUrlByForm(new FormData(window['catalogForm']));

        return false;
    }
}
